module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="phx-tabs-'+
((__t=(id))==null?'':__t)+
'" class="phx-tabs-container notranslate">\r\n    <ul>\r\n        <li aria-controls="home'+
((__t=(id))==null?'':__t)+
'">\r\n            <div tabindex="0">\r\n                <a href="#home'+
((__t=(id))==null?'':__t)+
'" class="cw-ui-tabs-home">\r\n                    '+
((__t=(nom))==null?'':__t)+
'\r\n                </a>\r\n                <span class="cw-tab-plein-ecran">\r\n                </span>\r\n            </div>\r\n        </li>\r\n    </ul>\r\n    <div id="home'+
((__t=(id))==null?'':__t)+
'" class="phx-proto-resizable phx-simple-panel">\r\n        <div class="phx-details-header-text">\r\n            '+
((__t=(nom))==null?'':__t)+
' Accueil</div>\r\n    </div>\r\n</div>';
}
return __p;
};
